export default __webpack_public_path__ + "settings.ad490654659b4ee9.svg";